import * as React from 'react';

import NewsIndexList from '@/components/layouts/News/IndexList';
import { getNewsTypeName } from '@/lib/news';
import { Content, NewsType } from '@/pages/News/types';

import { ButtonWrapper, Container, LinkButton, Title } from './style';

interface TopNewsProps {
  type: NewsType;
  contentsList: Content[];
  moreFlag: boolean;
}

const TopNews: React.FC<TopNewsProps> = ({ type, contentsList, moreFlag }) => {
  return (
    <Container>
      <Title>{getNewsTypeName(type)}</Title>
      <NewsIndexList type={type} contentsList={contentsList} isTop />
      {moreFlag && (
        <ButtonWrapper>
          <LinkButton to={`/${type}`}>もっと見る</LinkButton>
        </ButtonWrapper>
      )}
    </Container>
  );
};

export default TopNews;
